import { Checkbox, Flex, Text } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { ReactComponent as OutlineInfoIcon } from 'assets/icons/outline_info.svg';
import { Toggletip } from 'modules/common/components/Toggletip';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

const StyledOutlineInfoIcon = styled(OutlineInfoIcon)`
  & path {
    stroke: var(--vg-colors-upgrade-blue-500);
  }
`;

interface ScaleCheckboxProps {
  isScaled: boolean;
  disabled?: boolean;
  onChangeScaled: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const ScaleCheckbox = ({ isScaled, disabled, onChangeScaled }: Readonly<ScaleCheckboxProps>) => {
  const { t } = useTranslation('editor_toolbar_page_menu', { useSuspense: false });

  return (
    <Flex>
      <Checkbox isChecked={isScaled} onChange={onChangeScaled} disabled={disabled} mr={2}>
        <Text fontSize={'sm'}>{t('pageSize.scaleCheckbox.label')}</Text>
      </Checkbox>
      <Toggletip
        hasArrow={true}
        placement={'bottom'}
        icon={<StyledOutlineInfoIcon />}
        buttonAriaLabel={t('pageSize.scaleCheckbox.buttonAriaLabel')}
        contentStyle={{ width: '210px' }}
      >
        <Text size={'sm'} mb={2} textAlign={'left'}>
          {t('pageSize.scaleCheckbox.info')}
        </Text>
      </Toggletip>
    </Flex>
  );
};

export default ScaleCheckbox;
